module.exports = __webpack_public_path__ + "prod/1.42.2/img/footerthree.a6bc7122.png";